import { RM08_03 } from "./RM08_03";

export const RM08_02 = {
  selectedValueColumn: "Region",
  selectedTitle: "District",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "District",
        binding: {
          data: {
            columns: [
              {
                name: "District",
                columnName: "DistrictName",
                width: "450px",
                align: "left",
                sortable: true
              },
              {
                name: "Actual Visits",
                columnName: "Coverage",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Planned Visits",
                columnName: "Target",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Call Rate",
                columnName: "CallRate",
                width: "180px",
                align: "center",
                sortable: true,
                percent: true
              },
            ],
            title: "DistrictName",
            endpoint: "SFE_RM08.2",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "RegionCode", value: "" },
              { key: "Region", value: "" }
            ],
          },
          context: {
            point: {
              onClick: RM08_03,
            },
          },
        },
      },
    },
  ],
};